import { common } from '@neo-one/client-common';
import { Hash160ContractParameter } from '@neo-one/node-core';
import { StackItemBase } from './StackItemBase';
export class UInt160StackItem extends StackItemBase {
    constructor(value) {
        super();
        this.value = value;
    }
    asUInt160() {
        return this.value;
    }
    asBuffer() {
        return common.uInt160ToBuffer(this.value);
    }
    toContractParameter(_seen = new Set()) {
        return new Hash160ContractParameter(this.value);
    }
}

//# sourceMappingURL=UInt160StackItem.js.map
